const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE)

export const apiClientCartsToPay = {
	fetchCartsToPay: async (clientUUID: string) => {
		const { data } = await apiCommon<ICart[]>(`${groupPrefix}/clients/${clientUUID}/carts-to-pay`, {
			method: 'GET',
			...createQuery(null, {}),
		})
		return { data: data.map(Cart) }
	},
}
